<template lang="pug">
.d-flex.align-center
  g-btn(icon, @click="disabled = !disabled", :disabled="!inputValue", :class="{ 'primary--text': !disabled }")
    v-icon mdi-pencil
  v-checkbox(
    :disabled="!disabled",
    v-bind="{ inputValue }"
    @change="input($event, localValue)",
  )
  v-text-field(
    :value="localValue.label",
    :label="`${localValue.name}`",
    :disabled="disabled",
    @change="changeLabel($event, localValue)",
  )
</template>

<script>
export default {
  props: {
    value: null,
    field: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    disabled: true,
    localValue: null,
    inputValue: false,
  }),
  methods: {
    input(event, field) {
      this.inputValue = event;
      this.$emit('change', { event, field });
    },
    changeLabel(label, field) {
      field.label = label;
      this.disabled = true;
      this.inputValue = true;
      this.input(true, field);
    },
  },
  created() {
    this.inputValue = !!this.value;
    this.localValue = this.value || this.field;
  },
}
</script>
